const MoreIcon = ({
  color = "#333333",
  size = 24,
}: {
  color: string;
  size: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="4" r="2" fill={color} />
      <circle cx="12" cy="12" r="2" fill={color} />
      <circle cx="12" cy="20" r="2" fill={color} />
    </svg>
  );
};

export default MoreIcon;
